// You can write more code here

/* START OF COMPILED CODE */

import TransitionBase from "../core/derived-classes/TransitionBase";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class TransitionBat extends TransitionBase {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 960, y ?? 384);

    // transitionBat
    const transitionBat = scene.add.image(0, 0, "common", "transition-bat.png");
    this.add(transitionBat);

    // transitionBatSmall
    const transitionBatSmall = scene.add.image(0, -128, "common", "transition-bat.png");
    transitionBatSmall.scaleX = 0.3;
    transitionBatSmall.scaleY = 0.3;
    this.add(transitionBatSmall);

    // spinnerCircle
    const spinnerCircle = scene.add.image(0, 160, "common", "circle-white-large.png");
    spinnerCircle.scaleX = 0.5;
    spinnerCircle.scaleY = 0.5;
    spinnerCircle.tintTopLeft = 16776960;
    spinnerCircle.tintTopRight = 16776960;
    spinnerCircle.tintBottomLeft = 16776960;
    spinnerCircle.tintBottomRight = 16776960;
    this.add(spinnerCircle);

    // batSpinner
    const batSpinner = scene.add.image(0, 160, "common", "batsymbol-yellow.png");
    batSpinner.scaleX = 0.9;
    batSpinner.scaleY = 0.9;
    batSpinner.tintFill = true;
    batSpinner.tintTopLeft = 0;
    batSpinner.tintTopRight = 0;
    batSpinner.tintBottomLeft = 0;
    batSpinner.tintBottomRight = 0;
    this.add(batSpinner);

    this.transitionBat = transitionBat;
    this.transitionBatSmall = transitionBatSmall;
    this.spinnerCircle = spinnerCircle;
    this.batSpinner = batSpinner;

    /* START-USER-CTR-CODE */
    /* END-USER-CTR-CODE */
  }

  private transitionBat: Phaser.GameObjects.Image;
  private transitionBatSmall: Phaser.GameObjects.Image;
  private spinnerCircle: Phaser.GameObjects.Image;
  private batSpinner: Phaser.GameObjects.Image;

  /* START-USER-CODE */

  protected spinnerTween: Phaser.Tweens.Tween | undefined;

  private coveredCallback: (() => void) | undefined;
  private doneCallback: (() => void) | undefined;

  public activate(coveredCallback?: () => void, doneCallback?: () => void) {
    if (coveredCallback) this.coveredCallback = coveredCallback;
    if (doneCallback) this.doneCallback = doneCallback;

    this.transitionIn();
    this.scene.time.delayedCall(1000, this.transitionOut, [], this);
    if (this.doneCallback) this.scene.time.delayedCall(500, this.doneCallback);
  }

  public override show(onComplete?: (() => void) | undefined): void {
    this.transitionReset();
    this.transitionIn(onComplete);
  }

  public override hide(onComplete?: () => void) {
    this.transitionOut(onComplete);
  }

  protected transitionInInit() {
    this.transitionBat.scale = 0;
    this.transitionBatSmall.scale = 0;

    this.spinnerCircle.scale = 0;
    this.batSpinner.scale = 0;
    this.batSpinner.angle = 0;
  }

  protected transitionIn(onComplete?: () => void) {
    this.scene.add.tween({
      targets: this.transitionBat,
      scaleX: { from: 0, to: 4 },
      scaleY: { from: 0, to: 4 },
      duration: 1000,
      ease: Phaser.Math.Easing.Cubic.InOut
    });
    this.scene.add.tween({
      targets: this.transitionBatSmall,
      scaleX: { from: 0, to: 0.4 },
      scaleY: { from: 0, to: 0.4 },
      duration: 300,
      ease: Phaser.Math.Easing.Cubic.InOut,
      delay: 500,
      onComplete: onComplete
    });

    this.scene.add.tween({
      targets: this.spinnerCircle,
      scaleX: { from: 0, to: 0.5 },
      scaleY: { from: 0, to: 0.5 },
      duration: 250,
      ease: Phaser.Math.Easing.Cubic.InOut,
      delay: 500
    });
    this.scene.add.tween({
      targets: this.batSpinner,
      scaleX: { from: 0, to: 0.9 },
      scaleY: { from: 0, to: 0.9 },
      duration: 250,
      ease: Phaser.Math.Easing.Cubic.InOut,
      delay: 600
    });
    this.spinnerTween = this.scene.add.tween({
      targets: this.batSpinner,
      angle: { from: 0, to: 360 },
      duration: 800,
      ease: Phaser.Math.Easing.Cubic.InOut,
      delay: 850,
      repeat: -1
    });
  }

  protected transitionOut(onComplete?: () => void) {
    this.coveredCallback?.();

    this.scene.add.tween({
      targets: this.transitionBatSmall,
      scaleX: { from: 0.4, to: 0 },
      scaleY: { from: 0.4, to: 0 },
      duration: 200,
      ease: Phaser.Math.Easing.Cubic.InOut
    });
    this.scene.add.tween({
      targets: this.transitionBat,
      scaleX: { from: 4, to: 0 },
      scaleY: { from: 4, to: 0 },
      duration: 500,
      ease: Phaser.Math.Easing.Cubic.InOut,
      onComplete: onComplete
    });

    this.scene.add.tween({
      targets: this.spinnerCircle,
      scaleX: { from: 0.5, to: 0 },
      scaleY: { from: 0.5, to: 0 },
      duration: 200,
      ease: Phaser.Math.Easing.Cubic.InOut
    });
    this.scene.add.tween({
      targets: this.batSpinner,
      scaleX: { from: 0.9, to: 0 },
      scaleY: { from: 0.9, to: 0 },
      duration: 200,
      ease: Phaser.Math.Easing.Cubic.InOut
    });

    if (this.spinnerTween) {
      this.spinnerTween.stop();
      this.spinnerTween = undefined;
    }
  }

  protected transitionReset(): void {
    this.transitionInInit();
  }

  protected startTransitionIdle(): void {}
  protected stopTransitionIdle(): void {}

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
